export default function Servicevilkar() {
  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-extrabold text-slate-900 mb-8">Servicevilkår</h1>

        <div className="prose prose-slate max-w-none">
          <p className="text-sm text-slate-600 mb-8">
            <strong>Senest opdateret:</strong> 30. oktober 2025
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">1. Generelt</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Disse servicevilkår gælder for brug af hjemmesiden plejesoestrene.dk, der drives af:
            </p>
            <p className="text-slate-700 leading-relaxed">
              <strong>Plejesøstrene ApS</strong><br />
              CVR: 45991768<br />
              Helgavej 26, 5230 Odense M<br />
              Email: info@plejesoestrene.dk<br />
              Telefon: 89801515
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">2. Tjenester</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Plejesøstrene ApS er et vikarbureau der formidler kontakt mellem:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4">
              <li><strong>Vikarer:</strong> Sygeplejersker, social- og sundhedsassistenter der søger vikaropgaver</li>
              <li><strong>Institutioner:</strong> Plejehjem, hjemmeplejen, bosteder, plejecentre og andre kommunale institutioner der søger kvalificeret personale</li>
            </ul>
            <p className="text-slate-700 leading-relaxed">
              Hjemmesiden bruges til information og kontaktformidling. Konkrete ansættelser, vikarforhold og kontrakter er reguleret af separate aftaler mellem Plejesøstrene ApS og de respektive parter.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">3. Brug af hjemmesiden</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Ved at bruge denne hjemmeside accepterer du:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2">
              <li>At give sandfærdige og korrekte oplysninger ved kontakt</li>
              <li>At overholde gældende dansk og EU-lovgivning</li>
              <li>At respektere immaterielle rettigheder (ophavsret, varemærker, design)</li>
              <li>Ikke at misbruge hjemmesiden til ulovlige formål</li>
              <li>Ikke at forsøge at få uautoriseret adgang til hjemmesidens systemer</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">4. Kontaktformular</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Henvendelser via kontaktformularen behandles i henhold til vores{" "}
              <a href="/privatlivspolitik" className="text-brand-600 hover:underline">Privatlivspolitik</a>.
            </p>
            <p className="text-slate-700 leading-relaxed mb-4">
              Vi bestræber os på at besvare henvendelser inden for 2-3 arbejdsdage.
            </p>
            <p className="text-slate-700 leading-relaxed">
              Indsendelse af en henvendelse via kontaktformularen udgør ikke en bindende aftale om ansættelse eller levering af tjenester.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">5. Ansvar og ansvarsfraskrivelse</h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3">Information på hjemmesiden</h3>
            <p className="text-slate-700 leading-relaxed mb-4">
              Plejesøstrene ApS bestræber sig på at sikre, at information på hjemmesiden er korrekt, opdateret og komplet.
              Vi kan dog ikke garantere:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4">
              <li>100% oppetid (tekniske fejl, vedligeholdelse eller lignende kan forekomme)</li>
              <li>At al information til enhver tid er fejlfri eller fuldstændig</li>
            </ul>

            <h3 className="text-xl font-semibold text-slate-900 mb-3">Ansvarsbegrænsning</h3>
            <p className="text-slate-700 leading-relaxed mb-4">
              Plejesøstrene ApS er ikke ansvarlige for:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2">
              <li>Indirekte tab, følgeskader eller tabt fortjeneste</li>
              <li>Tab som følge af midlertidigt nedbrud eller tekniske problemer</li>
              <li>Tab som følge af tredjeparters handlinger</li>
              <li>Virus eller anden skadelig software som måtte følge med brugen af hjemmesiden</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">6. Links til tredjeparter</h2>
            <p className="text-slate-700 leading-relaxed">
              Hjemmesiden kan indeholde links til eksterne hjemmesider eller ressourcer. Disse links er udelukkende til din bekvemmelighed.
              Plejesøstrene ApS er ikke ansvarlige for indhold, privatlivspolitikker eller praksis på eksterne hjemmesider.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">7. Immaterielle rettigheder</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Alt indhold på plejesoestrene.dk, herunder men ikke begrænset til:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4">
              <li>Tekst og artikler</li>
              <li>Billeder, grafik og illustrationer</li>
              <li>Logo og designelementer</li>
              <li>Kildekode og funktionalitet</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-4">
              ...er beskyttet af ophavsret og andre immaterielle rettigheder og tilhører Plejesøstrene ApS eller vores licensgivere, medmindre andet er angivet.
            </p>
            <p className="text-slate-700 leading-relaxed">
              Uautoriseret kopiering, distribution, ændring eller kommerciel udnyttelse af indholdet er forbudt uden forudgående skriftligt samtykke fra Plejesøstrene ApS.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">8. Ansættelse og vikarforhold</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Plejesøstrene ApS fungerer som vikarbureau i henhold til:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4">
              <li>Vikarloven</li>
              <li>Arbejdsmiljøloven</li>
              <li>Bemandingsdirektivet (direktiv 2008/104/EF)</li>
            </ul>
            <p className="text-slate-700 leading-relaxed">
              Specifikke vilkår for vikaraftaler og institutionssamarbejder fremgår af de individuelle kontrakter, som ikke er omfattet af disse generelle servicevilkår.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">9. Ændringer til servicevilkår</h2>
            <p className="text-slate-700 leading-relaxed">
              Vi forbeholder os retten til at ændre disse servicevilkår. Ændringer træder i kraft ved offentliggørelse på hjemmesiden.
              Væsentlige ændringer vil blive markeret tydeligt. Seneste opdateringsdato fremgår øverst på siden.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">10. Gældende lov og værneting</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Disse servicevilkår er underlagt dansk ret.
            </p>
            <p className="text-slate-700 leading-relaxed">
              Eventuelle tvister, som måtte opstå i forbindelse med disse vilkår, skal søges løst i mindelighed.
              Kan en løsning ikke findes, afgøres tvisten ved de danske domstole.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">11. Kontakt</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Spørgsmål eller kommentarer til disse vilkår kan rettes til:
            </p>
            <p className="text-slate-700 leading-relaxed">
              Email: <a href="mailto:info@plejesoestrene.dk" className="text-brand-600 hover:underline">info@plejesoestrene.dk</a><br />
              Telefon: <a href="tel:+4589801515" className="text-brand-600 hover:underline">89801515</a><br />
              Adresse: Helgavej 26, 5230 Odense M
            </p>
          </section>

          <div className="mt-12 pt-8 border-t border-slate-200">
            <p className="text-sm text-slate-600 mb-3">
              <strong>Relaterede dokumenter:</strong>
            </p>
            <ul className="list-disc pl-6 text-sm text-slate-600 space-y-1">
              <li><a href="/privatlivspolitik" className="text-brand-600 hover:underline">Privatlivspolitik</a> - Hvordan vi behandler personoplysninger</li>
              <li><a href="/cookiepolitik" className="text-brand-600 hover:underline">Cookiepolitik</a> - Hvordan vi bruger cookies</li>
              <li><a href="/tilgaengelighed" className="text-brand-600 hover:underline">Tilgængelighedserklæring</a> - Hjemmesidens tilgængelighed</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 text-center">
          <a
            href="/"
            className="btn btn-primary btn-lg"
          >
            Tilbage til hjemmesiden
          </a>
        </div>
      </div>
    </div>
  );
}
